export default [
  {
    path: "actPartTime/maleCardFree",
    name: "actPartTimeMaleCardFree",
    meta: {
      title: "签署灵活就业协议",
    },
    component: () => import("@/views/actPartTime/maleCardFree.vue"),
  },
  {
    path: "actPartTime/flexibleAgreements",
    name: "actPartTimeFlexibleAgreements",
    meta: {
      title: "协议",
    },
    component: () => import("@/views/actPartTime/flexibleAgreements.vue"),
  },
  {
    path: "actPartTime/index",
    name: "actPartTimeIndex",
    meta: {
      title: "兼职人员须知",
    },
    component: () => import("@/views/actPartTime/index.vue"),
  },
  {
    path: "actPartTime/signaturePage",
    name: "签名",
    component: () => import("@/views/actPartTime/signaturePage.vue"),
  },
  {
    path: "actPartTime/bill",
    name: "活动服务金账单确认",
    component: () => import("@/views/actPartTime/bill.vue"),
  },
  {
    path: "actPartTime/confirmResult",
    name: "活动服务金账单确认",
    component: () => import("@/views/actPartTime/confirmResult.vue"),
  },
  {
    path: "actPartTime/grantResult",
    name: "活动服务金账单确认",
    component: () => import("@/views/actPartTime/grantResult.vue"),
  },
  {
    path: "actPartTime/billDetail",
    name: "活动服务金账单详情",
    component: () => import("@/views/actPartTime/billDetail.vue"),
  },
  {
    path: "actPartTime/notFound",
    name: "notFound",
    component: () => import("@/views/actPartTime/notFound.vue"),
  },
];
